<template>
	<span
		class="indicator display-flex align-items-center"
		:class="{ 'indicator--valid': props.valid }"
		:data-test="`Indicator ${props.label}`"
	>
		<span class="show-for-sr">{{ validityScreenReaderText }}</span>
		<BaseSvgIcon :name="iconName" width="16" height="16" :fill="props.valid" />
		<span>
			{{ label }}
		</span>
	</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
	label?: string;
	valid?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	label: '',
	valid: false
});

const iconName = computed(() => {
	return props.valid ? 'check-validation-filled' : 'check-validation-unfilled';
});

const validityScreenReaderText = computed(() => {
	return props.valid ? `${props.label} is valid` : `${props.label} is invalid`;
});
</script>

<style scoped lang="scss">
@use '../../styles/constants/_colors.scss' as *;
@use 'sass:map';

.indicator {
	border-color: token('content-tertiary');
	color: token('content-secondary');
	gap: 0.75rem;

	&--valid {
		color: map.get($validation-colors, 'success');
		border-color: map.get($validation-colors, 'success');
	}
}
</style>
